module.exports = __webpack_public_path__ + "static/media/cl_5.3a99a673.jpg";